module.exports = __webpack_public_path__ + "public/images/shedule-ak-table.5a55e6a3b984914d9cdfa2cc4a6a693a.png";